import React, { useState } from "react";
import ClefSelector from './ClefSelector';
import GameTypeSelector from './GameTypeSelector';
import KeySelector from './KeySelector';
import QuestionCountSelector from './QuestionCountSelector';
import TimeLimitSelector from './TimeLimitSelector';

const Settings = props => {

  const [ gamePropertySetters ] = useState(props.gamePropertySetters);

  return (
    <div>
      <table className="settings-controller" border="0">
        <tbody>
          <tr valign="top">
            <td> <GameTypeSelector      callbacks={gamePropertySetters} gameType = {props.gameType}                                       /> </td>
            <td> <ClefSelector          callbacks={gamePropertySetters} gameType = {props.gameType} clef          = {props.clef}          /> </td>
            <td> <KeySelector           callbacks={gamePropertySetters} gameType = {props.gameType} kee           = {props.kee}           /> </td>
            <td> <QuestionCountSelector callbacks={gamePropertySetters} gameType = {props.gameType} questionCount = {props.questionCount} /> </td>
            <td> <TimeLimitSelector     callbacks={gamePropertySetters} gameType = {props.gameType} timeLimit     = {props.timeLimit}     /> </td>
          </tr>
        </tbody>
      </table>
    </div>
  );

}

export default Settings;


